import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import './assets/theme-file.less';
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
import axios from 'axios'
Vue.prototype.$http = axios

Vue.config.productionTip = false
Vue.use(Antd)
Vue.use(VXETable)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
